import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

export default function RefreshButton ({callback}) {

   const { t } = useTranslation();

return (

    <>
       <Button 
        style={{
            borderRadius: 2,
            backgroundColor: "#006455",
            fontSize: "14px"
            }}
            className="m-2"
            variant="contained"
            onClick={callback}>
               {t("refresh")}
            </Button>
    </>

)

}